export default __webpack_public_path__ + "static/media/fitness-tracker.055e2b41.png";